import {Colors} from "@bounce/shared/ui";
import type {Theme} from "@mui/material/styles";
import type {SystemStyleObject} from "@mui/system";

// Typed as a plain style object (not SxProps) so it can be spread into an sx literal.
export const outlinedInputSx: SystemStyleObject<Theme> = {
  minHeight: 36,
  fontSize: 14,
  "& input, & textarea, & .MuiSelect-select": {fontSize: 14},
  borderRadius: "8px",
  "@keyframes errorFlash": {
    "0%": {borderColor: "transparent"},
    "30%": {borderColor: Colors.red._900},
    "100%": {borderColor: Colors.red._900},
  },
  "&.Mui-error .MuiOutlinedInput-notchedOutline": {
    animation: "errorFlash 0.4s ease-out",
  },
  "&.Mui-focused": {
    backgroundColor: "transparent",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: Colors.blue._500,
    borderWidth: "1px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: Colors.tertiary._300,
    borderRadius: "8px",
  },
  "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
    WebkitBoxShadow: "0 0 0 100px white inset",
    WebkitTextFillColor: "inherit",
  },
  "& input:focus": {
    backgroundColor: "transparent",
  },
};

export const autocompleteChevronSx: Record<string, SystemStyleObject<Theme>> = {
  "& .MuiAutocomplete-popupIndicator": {
    transform: "rotate(180deg)",
    transition: "transform 0.25s ease-in-out",
  },
  "& .MuiAutocomplete-popupIndicatorOpen": {
    transform: "rotate(0deg)",
  },
};
